import * as urls from "../../api/C4S Decommission - Replacement/url";
import { postRequest } from "../../../services/RestServices";

export const submitReturnItem = async (payload) => {
  try {
    return await postRequest(urls.SUBMIT_RETURN_ITEM, payload);
  } catch (err) {
    return err;
  }
};
